import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

/**
 * Eigenschafts-Band (TES-1072, Teil C) — ersetzt das frühere Kennzahlen-Band
 * (TES-967, D5; illustrative Fantasie-Werte) durch belastbare Produkt-
 * eigenschaften als ✓-Badges. Komponentenname bleibt StatsBand (Bestandsname).
 */
export function StatsBand() {
  const { t } = useTranslation();

  const claims = [
    t("landing.industrial.claims.rbac"),
    t("landing.industrial.claims.offline"),
    t("landing.industrial.claims.multilingual"),
    t("landing.industrial.claims.audit"),
  ];

  return (
    <section className="border-y border-border bg-card py-16">
      <ScrollReveal>
        <ul className="mx-auto grid max-w-7xl grid-cols-1 gap-y-6 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:divide-x lg:divide-border/40 lg:px-8">
          {claims.map((claim) => (
            <li key={claim} className="flex items-center justify-center gap-3 px-6 sm:px-8">
              <Check className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
              <span className="font-display text-base font-bold text-foreground sm:text-lg">
                {claim}
              </span>
            </li>
          ))}
        </ul>
      </ScrollReveal>
    </section>
  );
}
